import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { xetTotNghiepLanXetApi } from "../../../api/xet-tot-nghiep/xetTotNghiepLanXetApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eXetTotNghiepLanXetActionIds, IXetTotNghiepLanXetActionTypes } from "../../action-types/xet-tot-nghiep/IXetTotNghiepLanXetActions";
import { IXetTotNghiepLanXet } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepLanXet";
import { IXetTotNghiepLanXetUpdateLockStatusRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepLanXetUpdateLockStatusRequest";
const mainActions = rootActions.xetTotNghiep.xetTotNghiepLanXet;

export function* xetTotNghiepLanXetSaga(): any {
    yield takeLatest(eXetTotNghiepLanXetActionIds.LOAD_START, loadWorker);
    yield takeEvery(eXetTotNghiepLanXetActionIds.SAVE_START, saveWorker);
    yield takeEvery(eXetTotNghiepLanXetActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eXetTotNghiepLanXetActionIds.UPDATE_LOCK_STATUS_START, updateLockStatusWorker);
}


function* loadWorker() : any {
    const response: IBaseResponse = yield xetTotNghiepLanXetApi.SelectAll();
    if (response.is_success) {
        yield put(mainActions.LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    }
    else {
        yield put(mainActions.LOAD_ERROR(response.message ?? "Có lỗi khi tải đợt xét tốt nghiệp"));
    }
}

function* saveWorker(action: IXetTotNghiepLanXetActionTypes) : any {
    const payload = action.payload as IXetTotNghiepLanXet;
    let response: IBaseResponse;
    if (payload.id_xet_tot_nghiep > 0) {
        response = yield xetTotNghiepLanXetApi.Update(payload.id_xet_tot_nghiep, payload);
    } else {
        response = yield xetTotNghiepLanXetApi.Insert(payload);
    }
    if (response.is_success) {
        yield put(mainActions.SAVE_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.SAVE_ERROR(response.message ?? "Có lỗi khi lưu đợt xét tốt nghiệp"));
    }
}

function* deleteWorker(action: IXetTotNghiepLanXetActionTypes) : any {
    const id = action.payload as number;
    const response: IBaseResponse = yield xetTotNghiepLanXetApi.Delete(id);
    if (response.is_success) {
        yield put(mainActions.DELETE_SUCCESS(response.data));
    } else {
        yield put(mainActions.DELETE_ERROR(response.message ?? "Có lỗi khi xóa đợt xét tốt nghiệp"));
    }
}

function* updateLockStatusWorker(action: IXetTotNghiepLanXetActionTypes) : any {
    const payload = action.payload as IXetTotNghiepLanXetUpdateLockStatusRequest;
    const response: IBaseResponse = yield xetTotNghiepLanXetApi.UpdateLockStatus(payload);
    if (response.is_success) {
        yield put(mainActions.UPDATE_LOCK_STATUS_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_LOCK_STATUS_ERROR(response.message ?? "Có lỗi khi cập nhật trạng thái khóa đợt xét tốt nghiệp"));
    }
}